import axios from '../../_utils/axios';
import store, { DELETE_LOADER, persistor } from '../../../store';

// ----------------------------------------------------------------------

const searchSensorsModel = async (
  setData: React.Dispatch<React.SetStateAction<{
    content: any[];
  }>>
) => {
  return await axios.get('water-quality-sensor-model/search-slice?page=0&size=10')
    .then((response) => {
      return setData(response.data.data);
    })
    .catch((error) => {
      const code = error.response.data.code;
      
      if ( error.code === 'ERR_BAD_RESPONSE' ) {
        persistor.purge();
        return window.location.href = '/alert';
      } else if ( code === 'ERR-001' || code === 'ERR-REISSUE' ) {
        persistor.purge();
        return window.location.href = '/login';
      } else {
        return Promise.reject(error);
      }
    })
    .finally(() => store.dispatch( DELETE_LOADER() ));
};

export default searchSensorsModel;